import script from "./ActiveAuthForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveAuthForm.vue?vue&type=script&setup=true&lang=js"

import "./ActiveAuthForm.vue?vue&type=style&index=0&id=f750b11a&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f750b11a"]])

export default __exports__